export default __webpack_public_path__ + "static/media/ic-circles.5c270619.svg";